import { FC } from "react";

import Box, { BoxProps } from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

import styles from "./styles";

interface HeroProps {
  title: string;
  subtitle: string;
  backgroundImage: string;
  caseStudyFolder?: string;
  boxProps?: BoxProps;
}

const Hero: FC<HeroProps> = ({
  title,
  subtitle,
  backgroundImage,
  caseStudyFolder = "pages/cases/puma",
  boxProps,
}) => {
  return (
    <Box component="section" display="grid" sx={styles.wrapper} {...boxProps}>
      <Box sx={styles.background(backgroundImage, caseStudyFolder)}>
        <Container sx={styles.container}>
          <Typography variant="h1" component="h1" sx={styles.title}>
            {title}
          </Typography>
          <Typography variant="h3" sx={styles.subtitle}>
            {subtitle}
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default Hero;
